module.exports = __webpack_public_path__ + "static/media/hu.b10b63a8.svg";